import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Cushion,
  FlexContainer,
  LinearGradient,
  Rectangle,
  Shadow,
  Typography,
} from '@pitchero/react-ui';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';

const AvailabilityStatusBar = ({ isSelf, member, onClick, status }) => {
  const statusColor = status ? `availability_${status}` : 'availability_not_set';
  let transKey = 'availability_status_bar_';
  if (isSelf) {
    transKey += 'self_';
  }

  transKey += status || 'not_set';

  return (
    <Shadow>
      <Rectangle fill="white" radius="rounded" onClick={onClick} style={{ cursor: 'pointer' }}>
        <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
          <Rectangle radius="roundedLeft">
            <LinearGradient
              component="div"
              angle={60}
              stops={[
                [0, statusColor],
                ['50%', statusColor],
                ['50%', '#fff'],
              ]}
            >
              <Cushion horizontal="small" vertical="xsmall" component="div">
                <Avatar size={40} image={member.avatar} alt={member.firstName} boxShadow="dark" />
              </Cushion>
            </LinearGradient>
          </Rectangle>
          <Cushion left="xsmall">
            <Typography
              preset="name"
              component="div"
              color="black"
              align="left"
              style={{ flex: 1 }}
            >
              <Trans i18nKey={transKey} values={{ name: member.firstName }}>
                Are you available
              </Trans>
            </Typography>
          </Cushion>
          <Cushion right="medium">
            <Icon name="arrow-right" size={18} color="dustygrey" />
          </Cushion>
        </FlexContainer>
      </Rectangle>
    </Shadow>
  );
};

AvailabilityStatusBar.defaultProps = {
  isSelf: false,
  status: 'not_set',
};

AvailabilityStatusBar.propTypes = {
  isSelf: PropTypes.bool,
  member: PropTypes.shape({
    avatar: PropTypes.string,
    firstName: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['available', 'not_set', 'not_sure', 'unavailable']),
};
export default AvailabilityStatusBar;
